import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';

export const Wrapper = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  padding-bottom: 10px;
  text-align: right;

  ${(p) => injectAdaptive('bottom', p.theme.keyBoardHeightValues)}
`;
